import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDYjSHHReQywpLLiJS0fzydQe9QqEDECd0",
  authDomain: "clone-1c8cd.firebaseapp.com",
  databaseURL: "https://clone-1c8cd.firebaseio.com",
  projectId: "clone-1c8cd",
  storageBucket: "clone-1c8cd.appspot.com",
  messagingSenderId: "921863701681",
  appId: "1:921863701681:web:b077dd115abc5a8e3c8e90",
  measurementId: "G-NYX6Z96E8X",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
